import { useEffect, useMemo, useState } from 'react';
import type { NFLGameInputs } from '@library/types/simulations';
import { Select } from '@library/components/selects';

export const YesNoOverride = ({
  currentValue,
  field,
  onSetGameOverrides
}: {
  currentValue: boolean;
  field: keyof NFLGameInputs;
  onSetGameOverrides: (field: keyof NFLGameInputs, value: boolean) => void;
}) => {
  const [yes, setYes] = useState(currentValue);

  const handleToggleYesNo = useMemo(
    () => (value: boolean) => {
      onSetGameOverrides(field, value);
    },
    [field, onSetGameOverrides]
  );

  useEffect(() => {
    if (currentValue !== yes) {
      handleToggleYesNo(yes);
    }
  }, [currentValue, yes, handleToggleYesNo]);

  return (
    <Select
      size="small"
      options={[
        { key: 'Yes', name: 'Yes', value: 'Yes' },
        { key: 'No', name: 'No', value: 'No' }
      ]}
      label="Grass Field?"
      value={currentValue ? 'Yes' : 'No'}
      onChange={(value) => setYes(value.value === 'Yes')}
      className="font-heebo text-soClean-100 disabled:text-soClean-160 border-soFresh-140 !h-8 !min-h-[32px] w-16 rounded-md bg-transparent px-0 text-center text-sm font-medium leading-5 tracking-tight"
    />
  );
};
